import styled from "styled-components";

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const Highlight = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;

  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
    grid-template-columns: 1fr;
  }
  @media ${({ theme }) => theme.devices.mobileL} {
    gap: 4px;
  }
`;

export const HighlightSection = styled.div`
  display: grid;
  grid-template-rows: 2fr 1fr;
  gap: 16px;

  @media ${({ theme }) => theme.devices.tablet} {
    display: flex;
    flex-direction: column;
  }
`;

export const HighlightCard = styled.div`
  display: flex;
  gap: 16px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.white.normal};
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
  padding: 12px;
  cursor: pointer;
`;

interface IHighlightCardLarger {
  isMobileBigger?: boolean;
}

export const HighlightCardLarger = styled.div<IHighlightCardLarger>`
  display: flex;
  border-radius: 12px;
  align-items: end;
  position: relative;
  cursor: pointer;

  &:after {
    content: "Em destaque";
    position: absolute;
    top: 6px;
    right: 12px;
    width: fit-content;
    border-radius: 32px;
    padding: 0px 10px;
    color: #fff;
    background-color: ${({ theme }) => theme.colors.green.normal};
  }

  @media ${({ theme }) => theme.devices.tablet} {
    min-height: ${({ isMobileBigger = false }) =>
      isMobileBigger ? "400px" : "250px"};
  }
`;

export const HighlightOnlyCard = styled.div<IHighlightCardLarger>`
  display: flex;
  height: 100%;
  min-height: 200px;
  border-radius: 12px;
  align-items: end;
  position: relative;
  cursor: pointer;

  @media ${({ theme }) => theme.devices.tablet} {
    min-height: ${({ isMobileBigger = false }) =>
      isMobileBigger ? "400px" : "250px"};
  }
`;

export const HighlightCardTitle = styled.h2`
  color: #fff;
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: bold;
  padding: 6px 12px;
  position: absolute;
`;

interface IHighlightCardImage {
  src: string;
  isBlur?: boolean;
}

export const HighlightCardImage = styled.div<IHighlightCardImage>`
  display: flex;
  align-items: end;
  height: 100%;
  width: 100%;
  border-radius: 12px;
  background-image: url(${({ src }) => src});
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  filter: ${({ isBlur = true }) =>
    isBlur ? "brightness(0.7)" : "brightness(1)"};
`;

export const HighlightCardImageNoFilter = styled.div<IHighlightCardImage>`
  display: flex;
  align-items: end;
  height: 100%;
  width: 100%;
  border-radius: 12px;
  background-image: url(${({ src }) => src});
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
  cursor: pointer;
`;

export const Carousel = styled.div`
  display: flex;
  height: 60%;
  width: 40%;
  border-radius: 6px;

  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%
    padding: 0;
  }
  
  .carousel-container {
    width: 100%;
  }
  .carousel-content {
    height: 100%;
  }
  `;

interface ICarouselCardsProps {
  src?: string | null;
  aspectRatio: number;
}

export const CarouselCard = styled.div`
  display: flex;
  border-radius: 12px;
  align-items: end;
  justify-content: center;
  position: relative;
  width: 100%;

  @media ${({ theme }) => theme.devices.laptop} {
    min-height: 400px;
  }
`;

export const CarouselImage = styled.div<ICarouselCardsProps>`
  position: absolute; /* Torna a imagem um plano de fundo do card */
  top: 0;
  left: 15;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #000000;
  background-image: url(${({ src }) => src});
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
  z-index: 0; /* Certifica-se de que a imagem fique atrás dos outros componentes */

  @media ${({ theme }) => theme.devices.tablet} {
    height: 100%;
    background-size: ${({ aspectRatio }) =>
      aspectRatio >= 3.5 ? "cover" : "contain"};
  }
`;

export const CarouselTitle = styled.h2`
  color: ${({ theme }) => theme.colors.white.normal};
  font-size: ${({ theme }) => theme.fontSizePx.md2};
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.inter};
  margin: 0;
  padding: 0 20px;
  z-index: 1;
  @media ${({ theme }) => theme.devices.mobileL} {
    font-size: ${({ theme }) => theme.fontSizePx.mm};
    padding: 0 10px;
  }
`;

export const Cards = styled.div`
  display: flex;
  gap: 8px;
  flex: 1;
  flex-direction: column;
`;

export const Card = styled.div`
  display: flex;
  height: 196px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white.normal};
  cursor: pointer;
  position: relative;
`;

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 6px;
  filter: brightness(0.7);
  object-fit: cover;
`;

export const CardTitle = styled.a`
  font-weight: bold;
  text-decoration: none;
  font-size: 20px;
  color: ${({ theme }) => theme.colors.white.normal};
  font-family: ${({ theme }) => theme.fonts.inter};
  position: absolute;
  left: 15%;
  max-width: 70%;
  transition: 0.3s;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  bottom: 15%;

  &:hover {
    filter: opacity(0.8);
  }
`;

export const LinkTitle = styled.a`
  text-decoration: none;
  color: #007185;
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSize.md2};
  font-family: ${({ theme }) => theme.fonts.inter};
  text-align: right;
  text-transform: initial;
  cursor: pointer;
  opacity: 0.8;

  &:hover {
    text-decoration: underline;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`;

export const CarouselContent = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BtnCarouselCard = styled.button`
  background: ${({ theme }) => theme.colors.newGreen.green3};
  color: ${({ theme }) => theme.colors.white.normal};
  border: none;
  border-radius: 100px;
  cursor: pointer;
  height: 27px;
  margin-left: 10px;
  text-transform: uppercase;
  position: relative;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 300;
  font-size: 14px;
  display: inline-block;
  max-width: 80px;
  white-space: nowrap;
`;

export const FirstLineCards = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
export const SecondLineCards = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const CardBtnType = styled.button`
  background: ${({ theme }) => theme.colors.newGreen.green3};
  color: ${({ theme }) => theme.colors.white.normal};
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 300;
  font-size: 14px;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  height: 27px;
  padding: 0 12px;
  text-transform: uppercase;
  position: absolute;
  left: 15%;
  top: 70%;
  z-index: 1;
  transition: background 0.3s;
  @media (max-width: 450px) {
    left: 50%;
    transform: translateX(-50%);
    text-wrap: nowrap; /* Impede que o texto quebre em várias linhas */
  }

  &:hover {
    background: ${({ theme }) => theme.colors.green.dark};
  }
`;

export const SectionCardsBottom = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

// ################## left-side cards

export const LeftSectionCardsBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: calc(50% - 4px);
  aspect-ratio: 2/1;
  overflow: hidden;

  position: relative;

  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
    overflow: hidden; /* Esconde o conteúdo que ultrapassa o limite do contêiner */
    border-radius: 6px;
  }
`;

export const ImageLeftSectionCardsBottom = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 6px;
  filter: brightness(0.7);
  object-fit: cover;
  position: absolute; /* Posiciona a imagem no plano de fundo */
  top: 0; /* Garante que está no topo do contêiner */
  left: 0; /* Garante que está no canto esquerdo */
  z-index: 0; /* Envia a imagem para o fundo */
`;

export const CardContent = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  padding-left: 40px;
  color: white;

  @media ${({ theme }) => theme.devices.tablet} {
    padding-left: 16px;
    gap: 0px;
  }
  @media ${({ theme }) => theme.devices.mobileM} {
    padding: 40px;
    gap: 0px;
  }
`;

export const Tag = styled.span`
  background: ${({ theme }) => theme.colors.newGreen.green3};
  color: ${({ theme }) => theme.colors.white.normal};
  border: none;
  border-radius: 100px;
  cursor: pointer;
  height: 27px;
  text-transform: uppercase;
  position: relative;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 300;
  font-size: 14px;
  display: flex; /* Flexbox para centralização */
  justify-content: center; /* Centraliza horizontalmente */
  align-items: center; /* Centraliza verticalmente */
  padding: 0 12px; /* Adiciona espaçamento interno para melhor estética */
  max-width: fit-content; /* Ajusta o tamanho conforme o conteúdo */
  @media ${({ theme }) => theme.devices.mobileM} {
    font-size: 12px;
    padding: 0 8px; /* Ajusta o espaçamento interno para telas menores */
  }
  @media ${({ theme }) => theme.devices.mobileXL} {
    font-size: 18px;
    padding: 0 8px; /* Ajusta o espaçamento interno para telas menores */
  }
`;

export const TextWrap = styled.div`
  justify-content: center;
`;

export const Title = styled.h3`
  color: ${({ theme }) => theme.colors.white.normal};
  font-size: ${({ theme }) => theme.fontSizePx.lg};
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 700;
  margin-top: 8px;
  margin-bottom: 0px;
  max-width: 60%;
  @media ${({ theme }) => theme.devices.tablet} {
    font-size: ${({ theme }) => theme.fontSizePx.md2};
    max-width: 100%;
  }
  @media (max-width: 890px) {
    font-size: ${({ theme }) => theme.fontSizePx.md};
    max-width: 100%;
  }
  @media ${({ theme }) => theme.devices.mobileXL} {
    font-size: ${({ theme }) => theme.fontSizePx.md2};
    margin-top: 14px;
  }
  @media ${({ theme }) => theme.devices.mobileM} {
    font-size: ${({ theme }) => theme.fontSizePx.mm};
    margin-top: 4px;
  }
`;

export const Description = styled.p`
  font-size: 22px;
  font-family: ${({ theme }) => theme.fonts.inter};
  margin-top: 8px;
  max-width: 60%;
  @media ${({ theme }) => theme.devices.tablet} {
    max-width: 100%;
    font-size: ${({ theme }) => theme.fontSizePx.mm};
  }
  @media (max-width: 890px) {
    font-size: ${({ theme }) => theme.fontSizePx.sm};
    max-width: 100%;
  }
`;

export const Button = styled.button`
  background-color: #1cbf63;
  color: white;
  font-size: 14px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 600;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  align-self: flex-start;
  text-wrap: nowrap;

  @media ${({ theme }) => theme.devices.tablet} {
    font-size: 12px;
    padding: 8px 12px;
  }

  @media ${({ theme }) => theme.devices.mobileL} {
    font-size: 12px;
    padding: 6px 8px;
  }

  &:hover {
    background-color: #139948;
  }
`;

// ################## right-side cards

export const RightSectionCardsBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: calc(50% - 4px);
  height: 100%;
  aspect-ratio: 2/1;
  overflow: hidden;

  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
    border-radius: 6px;
  }
  @media ${({ theme }) => theme.devices.mobileL} {
    width: 100%;
  }
`;

export const CarouselCardBottom = styled.div`
  display: flex;
  border-radius: 12px;
  align-items: end;
  position: relative;
  width: 100%;
  height: 100%;
  aspect-ratio: 16/9;
  @media ${({ theme }) => theme.devices.tablet} {
    min-height: auto;
  }
`;

export const BtnCarouselCardBottom = styled.button`
  background: ${({ theme }) => theme.colors.newGreen.green3};
  color: ${({ theme }) => theme.colors.white.normal};
  border: none;
  border-radius: 100px;
  cursor: pointer;
  height: 27px;
  padding: 0 12px;
  text-transform: uppercase;
  position: absolute;
  left: 75px;
  top: 52px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 300;
  font-size: 14px;
  z-index: 1;
`;

export const CarouselTitleBottom = styled.p`
  color: ${({ theme }) => theme.colors.white.normal};
  font-size: ${({ theme }) => theme.fontSizePx.lg};
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 700;
  line-height: 30px;
  position: absolute;
  top: 60px;
  left: 75px;
  max-width: 60%;
  line-height: 34px;
  overflow: hidden; /* Esconde o texto excedente */
  text-overflow: ellipsis; /* Adiciona reticências */
  display: -webkit-box; /* Necessário para suportar múltiplas linhas */
  -webkit-line-clamp: 1; /* Define o número máximo de linhas */
  -webkit-box-orient: vertical; /* Define a orientação do box */
`;

export const CarouselSub = styled.p`
  color: ${({ theme }) => theme.colors.white.normal};
  font-size: 22px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 400;
  max-width: 60%;
  overflow: hidden; /* Esconde o texto excedente */
  text-overflow: ellipsis; /* Adiciona reticências */
  display: -webkit-box; /* Necessário para suportar múltiplas linhas */
  -webkit-line-clamp: 2; /* Define o número máximo de linhas */
  -webkit-box-orient: vertical; /* Define a orientação do box */
  position: absolute;
  bottom: 113px; /* Ajuste o top para que fique abaixo do título */
  left: 75px;
  margin: 0;
`;

export const CarouselSubTitleBottom = styled.button`
  background: #ea7d24;
  color: ${({ theme }) => theme.colors.white.normal};
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 600;
  padding: 10px 16px;
  position: absolute;
  position: absolute;
  bottom: 53px;
  left: 75px;
  max-width: 50%;
`;

export const CardWeather = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  z-index: 1;
  position: absolute;
  bottom: 24px;
  left: 60px;
  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
    align-items: start;
    left: 16px;
  }
`;

export const CardWeatherTitle = styled.h3`
  font-size: 22px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 700;
  margin: 0;
  color: ${({ theme }) => theme.colors.white.normal};
  margin-right: 100px;
  @media ${({ theme }) => theme.devices.tablet} {
    margin: 0;
  }
`;

export const CardWeatherContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media ${({ theme }) => theme.devices.tablet} {
    gap: 4px;
  }
`;

export const CardWeatherIcon = styled.img`
  width: 40px;
  height: 40px;
`;

export const CardWeatherTitleText = styled.p`
  font-size: 16px;
  font-family: ${({ theme }) => theme.fonts.inter};
  margin: 0;
  color: ${({ theme }) => theme.colors.white.normal};
  display: flex;
  @media ${({ theme }) => theme.devices.tablet} {
    font-size: 12px;
  }
`;

export const CardWeatherText = styled.p`
  font-size: 22px;
  font-family: ${({ theme }) => theme.fonts.inter};
  margin: 0;
  color: ${({ theme }) => theme.colors.white.normal};
  @media ${({ theme }) => theme.devices.tablet} {
    font-size: 16px;
    margin: 0;
    padding: 0;
  }
`;

export const CardWeatherBloqued = styled.p`
  font-size: 20px;
  font-family: ${({ theme }) => theme.fonts.inter};
  margin: 0;
  color: ${({ theme }) => theme.colors.white.normal};
`;
